import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    static get targets () {
        return ['vacationFrom', 'vacationTill', 'vacationDays'];
    }

    vacationFromTargetConnected(element) {
        element.addEventListener('change', ()=>{
            let d = new Date(element.value);
            d.setDate(d.getDate());
            this.vacationTillTarget._flatpickr.setDate(d);
            this.vacationTillTarget._flatpickr.set('minDate', d);

            let month = d.getMonth() + 1;
            let day = d.getDate();

            if (day < 10) {
                day = '0' + day;
            }

            if (month < 10) {
                month = '0' + month;
            }

            this.vacationTillTarget.value = `${d.getFullYear()}-${month}-${day}`;
            this.updateSelectedDays();
        });
    }

    vacationTillTargetConnected(element) {
        element.addEventListener('change', ()=>{
            this.updateSelectedDays();
        });
    }

    updateSelectedDays() {
        if (this.vacationFromTarget.value === '' || this.vacationTillTarget.value === '') {
            this.vacationDaysTarget.textContent = 0;
            return;
        }

        const fromDate = new Date(this.vacationFromTarget.value);
        const tillDate = new Date(this.vacationTillTarget.value);

        const diffTime = tillDate - fromDate;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

        if (diffDays > 0) {
            this.vacationDaysTarget.textContent = diffDays.toString();
        } else {
            this.vacationDaysTarget.textContent = 0;
        }
    }
}
